import axios from 'axios';

const getBaseURL = () => {
  const buildEnv = process.env.REACT_APP_BUILD_ENV || process.env.NODE_ENV;
  console.log(`${buildEnv} --- ${window.Capacitor}`);
  if (window.Capacitor) {
    // Mobile app
    return buildEnv === 'production' ? process.env.REACT_APP_MOBILE_BACKEND_URL : 'http://192.168.1.3:8000';
  } else {
    // Web browser
    return process.env.REACT_APP_BACKEND_URL;
  }
};

// Local - http://localhost:8000/
// LAN - http://192.168.29.147:8000/
const backendInstance = axios.create({
  baseURL: getBaseURL(),
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 60000,
});

export default backendInstance;
